import { render, staticRenderFns } from "./extra-category-tabs.vue?vue&type=template&id=711fb454&scoped=true&lang=pug&"
import script from "./extra-category-tabs.vue?vue&type=script&lang=js&"
export * from "./extra-category-tabs.vue?vue&type=script&lang=js&"
import style0 from "./extra-category-tabs.vue?vue&type=style&index=0&id=711fb454&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711fb454",
  null
  
)

export default component.exports